<template>
    <div class="ayuda-container" data-app>
        <div class="doc-section ayuda-scope">
            <div class="container-fluid px-0">

                <!-- Selector Plataforma -->
                <div class="mb-6">
                    <BotonesNavegacion @cambio-plataforma="plataformaActual = $event" />
                </div>

                <header class="header-container mb-4">
                    <h1 class="main-title">Niveles de Usuario y Permisos</h1>

                    <p class="description">
                        El sistema cuenta con 3 niveles de usuarios: Master, Administrador y Usuario Final.
                        A continuación se indican los permisos con los que cuenta cada uno.
                    </p>
                </header>

                <!-- Tabs -->
                <div class="tabs-container mb-4">

                    <button
                        class="tab-btn"
                        :class="{ active: tipoUsuario === 'final' }"
                        @click="tipoUsuario = 'final'"
                    >
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round">
                            <circle cx="12" cy="8" r="4"/>
                            <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
                        </svg>

                        Usuario Final
                    </button>

                    <button
                        class="tab-btn"
                        :class="{ active: tipoUsuario === 'administrador' }"
                        @click="tipoUsuario = 'administrador'"
                    >
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round">
                            <circle cx="9" cy="7" r="3"/>
                            <path d="M3 20c0-3.3 2.7-6 6-6"/>
                            <circle cx="17" cy="11" r="3"/>
                            <path d="M11 20c0-3.3 2.7-6 6-6h0"/>
                        </svg>

                        Administrador
                    </button>

                    <button
                        class="tab-btn"
                        :class="{ active: tipoUsuario === 'master' }"
                        @click="tipoUsuario = 'master'"
                    >
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round">
                            <path d="M12 2l3 6.5L22 9l-5 4.9 1.2 7L12 18l-6.2 2.9L7 14 2 9l7-.5z"/>
                        </svg>

                        Master
                    </button>

                </div>

                <!-- Contenido Roles -->
                <div class="tab-content mb-5">

                    <!-- Usuario Final -->
                    <div v-if="tipoUsuario === 'final'">

                        <div class="role-header mb-4">
                            <span class="role-badge badge-final">Usuario Final</span>

                            <p class="role-desc">
                                El usuario final cuenta con permisos para ver las pantallas de
                                Monitoreo, Histórico y Geocercas.
                            </p>
                        </div>

                        <div class="row">

                            <div class="col-12 col-md-4 mb-3">
                                <div class="permiso-card">
                                    <h4>Monitoreo</h4>
                                    <p>
                                        Visualiza en el mapa los dispositivos que tenga asignados
                                        y puede consultar su histórico.
                                    </p>
                                </div>
                            </div>

                            <div class="col-12 col-md-4 mb-3">
                                <div class="permiso-card">
                                    <h4>Histórico</h4>
                                    <p>
                                        Realiza consultas únicamente de los dispositivos
                                        que tiene asignados.
                                    </p>
                                </div>
                            </div>

                            <div class="col-12 col-md-4 mb-3">
                                <div class="permiso-card">
                                    <h4>Geocercas</h4>
                                    <p>
                                        Visualiza únicamente las geocercas que el usuario haya registrado.
                                    </p>
                                </div>
                            </div>

                        </div>

                    </div>

                    <!-- Administrador -->
                    <div v-if="tipoUsuario === 'administrador'">

                        <div class="role-header mb-4">
                            <span class="role-badge badge-admin">Administrador</span>

                            <p class="role-desc">
                                El administrador cuenta con permisos para ver Monitoreo,
                                Dispositivos, Histórico, Geocercas y Usuarios.
                            </p>
                        </div>

                        <div class="row">

                            <div class="col-12 col-md-4 mb-3">
                                <div class="permiso-card">
                                    <h4>Monitoreo</h4>
                                    <p>
                                        Visualiza los dispositivos que su grupo tenga asignados.
                                    </p>
                                </div>
                            </div>

                            <div class="col-12 col-md-4 mb-3">
                                <div class="permiso-card">
                                    <h4>Dispositivos</h4>
                                    <p>
                                        Visualiza el listado de dispositivos asignados
                                        y los que él registre en el sistema.
                                    </p>
                                </div>
                            </div>

                            <div class="col-12 col-md-4 mb-3">
                                <div class="permiso-card">
                                    <h4>Histórico</h4>
                                    <p>
                                        Realiza consultas de los dispositivos asignados a su grupo.
                                    </p>
                                </div>
                            </div>

                            <div class="col-12 col-md-6 mb-3">
                                <div class="permiso-card">
                                    <h4>Geocercas</h4>
                                    <p>
                                        Visualiza las geocercas del grupo de trabajo
                                        y las registradas por el propio usuario.
                                    </p>
                                </div>
                            </div>

                            <div class="col-12 col-md-6 mb-3">
                                <div class="permiso-card">
                                    <h4>Usuarios</h4>
                                    <p>
                                        Registra, edita y resetea contraseñas
                                        de los usuarios de su grupo.
                                    </p>
                                </div>
                            </div>

                        </div>

                    </div>

                    <!-- Master -->
                    <div v-if="tipoUsuario === 'master'">

                        <div class="role-header mb-4">
                            <span class="role-badge badge-master">Master</span>

                            <p class="role-desc">
                                El master cuenta con permisos para ver Monitoreo,
                                Dispositivos, Histórico, Geocercas, Usuarios,
                                Grupos y Configuraciones.
                            </p>
                        </div>

                        <div class="row">

                            <div class="col-12 col-md-4 mb-3">
                                <div class="permiso-card">
                                    <h4>Monitoreo</h4>
                                    <p>
                                        Visualiza todos los dispositivos registrados en el sistema.
                                    </p>
                                </div>
                            </div>

                            <div class="col-12 col-md-4 mb-3">
                                <div class="permiso-card">
                                    <h4>Dispositivos</h4>
                                    <p>
                                        Visualiza todos los dispositivos del sistema
                                        y el grupo al que pertenecen.
                                    </p>
                                </div>
                            </div>

                            <div class="col-12 col-md-4 mb-3">
                                <div class="permiso-card">
                                    <h4>Histórico</h4>
                                    <p>
                                        Realiza consultas de todos los dispositivos registrados en el sistema.
                                    </p>
                                </div>
                            </div>

                            <div class="col-12 col-md-4 mb-3">
                                <div class="permiso-card">
                                    <h4>Geocercas</h4>
                                    <p>
                                        Visualiza todas las geocercas con el nombre del usuario creador y su grupo.
                                    </p>
                                </div>
                            </div>

                            <div class="col-12 col-md-4 mb-3">
                                <div class="permiso-card">
                                    <h4>Usuarios</h4>
                                    <p>
                                        Registra, edita y resetea contraseñas
                                        de todos los usuarios del sistema.
                                    </p>
                                </div>
                            </div>

                            <div class="col-12 col-md-4 mb-3">
                                <div class="permiso-card">
                                    <h4>Grupos</h4>
                                    <p>
                                        Registra, edita, habilita o deshabilita
                                        los grupos de trabajo.
                                    </p>
                                </div>
                            </div>

                            <div class="col-12 mb-3">
                                <div class="permiso-card">
                                    <h4>Configuraciones</h4>
                                    <p>
                                        Registra configuraciones de IP del servidor,
                                        número de arduino, APN y radio para almacenamiento
                                        de posiciones estáticas.
                                    </p>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

                <hr class="section-divider my-5" />

                <!-- Filtro Vista Master -->
                <div class="mb-5">

                    <div class="section-title-bar mb-4">
                        <h2>Filtro Vista Master</h2>
                    </div>

                    <p class="section-desc">
                        Para utilizar la funcionalidad y ver el espacio de trabajo de un usuario final o administrador, 
                        es necesario iniciar sesión con el usuario master. Ir al menú y hacer clic sobre la opción <strong>Usuarios.</strong> Presionar el botón <strong>Ver</strong> representado por el icono de un ojo, 
                        ubicado en la columna de <strong>Acciones</strong> en la fila del usuario final o administrador que desea seleccionar.
                    </p>

                    <div class="carrusel-wrapper-box mb-4 p-2">

                        <transition name="fade" mode="out-in">
                            <CarruselAciqui
                                :key="plataformaActual + '-usuarios'"
                                :items="itemsListadoUsuarios"
                            />
                        </transition>

                    </div>

                    <div class="doc-note note-warning mb-5">

                        <svg class="note-icon"
                            width="15"
                            height="15"
                            viewBox="0 0 16 16"
                            fill="none">

                            <path
                                d="M8 2L14.9 14H1.1L8 2Z"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linejoin="round"/>

                            <circle
                                cx="8"
                                cy="11.5"
                                r="0.75"
                                fill="currentColor"/>

                        </svg>

                        <div class="note-body">
                            <span class="note-label">Nota</span>

                            <p>
                                Solo el usuario master tiene esta funcionalidad en el sistema. 
                                Todo los registros en el sistema al estar en la vista filtrada del usuario serán registradas por el sistema como del usuario master y no por el usuario seleccionado. 
                                Al cerrar sesión se perderá la selección del filtrado master.
                            </p>
                        </div>

                    </div>

                    <div class="row mx-0">

                        <!-- Usuario Final -->
                        <div class="col-12 col-lg-6 px-0 pr-lg-3 mb-4">

                            <div class="flow-card p-4 h-100">

                                <h3 class="flow-title mb-3">
                                    <span class="flow-num">1</span>
                                    Usuario Final
                                </h3>

                                <p class="flow-text mb-2">
                                    <strong>I.</strong>
                                    Se mostrará el ventana emergente con el mensaje “Esta seguro que, ¿Desea ver el espacio de trabajo del usuario final?” indicando el nombre del usuario seleccionado.
                                </p>

                                <p class="flow-text mb-2">
                                    <strong>II.</strong>
                                    Presionar el botón <strong>Aceptar.</strong>
                                </p>

                                <p class="flow-text mb-4">
                                    <strong>III.</strong>
                                    El sistema direccionará a la pantalla de monitoreo y mostrará
                                    el espacio de trabajo del usuario seleccionado.
                                </p>

                                <div class="flow-detail-card mb-4">

                                    <div class="flow-detail-section mb-3">

                                        <p class="flow-detail-title">
                                            <strong>A)</strong>
                                            En el menú lateral izquierdo se mostrarán las opciones:
                                        </p>

                                        <ul class="flow-detail-list">
                                            <li>
                                                <strong>a) Monitoreo:</strong>
                                                se mostrarán los dispositivos asignados al usuario,
                                                las ubicaciones guardadas por el usuario seleccionado
                                                y las alertas de los dispositivos asignados.
                                            </li>

                                            <li>
                                                <strong>b) Histórico:</strong>
                                                el usuario podrá consultar el historial
                                                de los dispositivos que tenga asignados.
                                            </li>

                                            <li>
                                                <strong>c) Geocercas:</strong>
                                                el usuario podrá visualizar las geocercas
                                                registradas por el usuario seleccionado.
                                            </li>
                                        </ul>

                                    </div>

                                    <div class="flow-detail-section">

                                        <p class="flow-detail-title">
                                            <strong>B)</strong>
                                            En la barra superior se mostrará del lado derecho:
                                        </p>

                                        <ul class="flow-detail-list">
                                            <li>
                                                <strong>a)</strong>
                                                El botón <strong>Regresar vista master</strong>,
                                                el cual permitirá al usuario master regresar
                                                a la configuración predeterminada.
                                            </li>

                                            <li>
                                                <strong>b)</strong>
                                                El nombre del usuario del cual está visualizando
                                                su espacio de trabajo.
                                            </li>
                                        </ul>

                                    </div>

                                </div>

                                <transition name="fade" mode="out-in">
                                    <CarruselAciqui
                                        :key="plataformaActual + '-final'"
                                        :items="carruselFiltroFinal"
                                    />
                                </transition>

                            </div>

                        </div>

                        <!-- Administrador -->
                        <div class="col-12 col-lg-6 px-0 pl-lg-3 mb-4">

                            <div class="flow-card p-4 h-100">

                                <h3 class="flow-title mb-3">
                                    <span class="flow-num">2</span>
                                    Administrador
                                </h3>

                                <p class="flow-text mb-2">
                                    <strong>I.</strong>
                                    Se mostrará el ventana emergente con el mensaje “Esta seguro que, ¿Desea ver el espacio de trabajo del administrador?” 
                                    indicando el nombre del usuario seleccionado.
                                </p>

                                <p class="flow-text mb-2">
                                    <strong>II.</strong>
                                    Presionar el botón Aceptar.
                                </p>

                                <p class="flow-text mb-4">
                                    <strong>III.</strong>
                                    El sistema direccionará a la pantalla de monitoreo y mostrará el espacio de trabajo del usuario seleccionado.
                                </p>

                                <div class="flow-detail-card mb-4">

                                    <div class="flow-detail-section mb-3">

                                        <p class="flow-detail-title">
                                            <strong>A)</strong>
                                            En el menú lateral izquierdo se mostrarán las opciones:
                                        </p>

                                        <ul class="flow-detail-list">
                                            <li>
                                                <strong>a) Monitoreo:</strong>
                                                se mostrarán los dispositivos asignados al usuario,
                                                las ubicaciones guardadas por el usuario seleccionado
                                                y las alertas de los dispositivos asignados.
                                            </li>

                                            <li>
                                                <strong>b) Dispositivos:</strong>
                                                se mostrará el listado de los dispositivos registrados y/o asignados al grupo de trabajo.
                                            </li>

                                            <li>
                                                <strong>c) Histórico:</strong>
                                                el usuario podrá consultar el historial
                                                de los dispositivos que tenga asignados.
                                            </li>

                                            <li>
                                                <strong>d) Geocercas:</strong>
                                                el usuario podrá visualizar las geocercas
                                                registradas por el usuario seleccionado.
                                            </li>

                                            <li>
                                                <strong>e) Estadísticas:</strong>
                                                se mostraran las estadísticas de los alertas, geocercas y dispositivos a los cuales el administrador esta asignado.
                                            </li>

                                            <li>
                                                <strong>f) Usuarios:</strong>
                                                se mostrará los usuarios registrados por el usuario así como también los que pertenecen a su equipo de trabajo.
                                            </li>

                                            <li>
                                                <strong>g) Grupos:</strong>
                                                podrá visualizar los grupos a los que esta asignado así como los usuarios asignados a dichos grupos.
                                            </li>
                                            
                                        </ul>

                                    </div>

                                    <div class="flow-detail-section">

                                        <p class="flow-detail-title">
                                            <strong>B)</strong>
                                            En la barra superior se mostrará del lado derecho:
                                        </p>

                                        <ul class="flow-detail-list">
                                            <li>
                                                <strong>a)</strong>
                                                El botón <strong>Regresar vista master</strong>,
                                                el cual permitirá al usuario master regresar
                                                a la configuración predeterminada.
                                            </li>

                                            <li>
                                                <strong>b)</strong>
                                                El nombre del usuario del cual está visualizando
                                                su espacio de trabajo.
                                            </li>
                                        </ul>

                                    </div>

                                </div>

                                <transition name="fade" mode="out-in">
                                    <CarruselAciqui
                                        :key="plataformaActual + '-admin'"
                                        :items="carruselFiltroAdmin"
                                    />
                                </transition>

                            </div>

                        </div>

                    </div>

                    <!-- Regresar Master -->
                    <div class="return-master-card p-4">

                        <div class="return-header mb-3">

                            <svg width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="return-icon">

                                <path d="M9 14L4 9l5-5"/>
                                <path d="M4 9h10a7 7 0 010 14h-1"/>

                            </svg>

                            <h3 class="return-title">
                                Regresar a la Vista Master
                            </h3>

                        </div>

                        <p class="flow-text mb-4">
                            Presione el botón
                            <strong>Regresar vista master</strong>
                            ubicado en la barra superior derecha.

                            Se mostrará una ventana de confirmación;
                            haga clic en <strong>Aceptar</strong>
                            para regresar o <strong>Cancelar</strong>
                            para continuar en la vista del usuario seleccionado.
                        </p>

                        <div class="carrusel-wrapper-box p-2">

                            <transition name="fade" mode="out-in">
                                <CarruselAciqui
                                    :key="plataformaActual + '-master'"
                                    :items="itemsRegresarMaster"
                                />
                            </transition>

                        </div>

                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
import CarruselAciqui from './Carruselimg.vue';
import BotonesNavegacion from './BotonesNavegacion.vue';

export default {
    name: 'NivelesUsuariosDoc',

    components: {
        CarruselAciqui,
        BotonesNavegacion
    },

    data() {
        return {
            tipoUsuario: 'final',
            plataformaActual: 'web',

            webData: {
                listadoUsuarios: [
                    {
                        nombre: "Listado de usuarios",
                        url: 'img/nivelesUsuarios/Listado_Usuarios_Registrados.png',
                        descripcion: "Listado de usuarios registrados en el sistema."
                    }
                ],

                regresarMaster: [
                    {
                        nombre: "Regresar vista master",
                        url: 'img/nivelesUsuarios/Confirmacion_Regresar_Vista_Master.png',
                        descripcion: "Confirmación para regresar a la vista master."
                    }
                ],

                filtroFinal: [
                    {
                        nombre: "I. Confirmación de Filtrado",
                        url: "img/nivelesUsuarios/Confirmacion_Filtrado_Vista_Usuario_Final.png",
                        descripcion: "Mensaje de confirmación para ver el espacio de trabajo del usuario final."
                    },
                    {
                        nombre: "II. Botón de Aceptar",
                        url: "img/nivelesUsuarios/Confirmacion_Filtrado_Vista_Usuario_Final_2.png",
                        descripcion: "Presionar el botón Aceptar."
                    },
                    {
                        nombre: "III. Vista Filtrada",
                        url: "img/nivelesUsuarios/Pantalla_Monitoreo_Filtrada_Usuario_Final.png",
                        descripcion: "Vista de monitoreo con permisos filtrados para usuario final."
                    }
                ],

                filtroAdmin: [
                    {
                        nombre: "I. Confirmación de Filtrado",
                        url: "img/nivelesUsuarios/Confirmacion_Filtrado_Vista_Administrador.png",
                        descripcion: "Mensaje de confirmación para ver el espacio de trabajo del administrador."
                    },
                    {
                        nombre: "II. Botón de Aceptar",
                        url: "img/nivelesUsuarios/Confirmacion_Filtrado_Vista_Administrador_2.png",
                        descripcion: "Presionar el botón Aceptar."
                    },
                    {
                        nombre: "III. Vista Filtrada",
                        url: "img/nivelesUsuarios/Pantalla_Monitoreo_Filtrada_Administrador.png",
                        descripcion: "Vista filtrada con permisos del administrador."
                    }
                ]
            },

            mobileData: {
                listadoUsuarios: [
                    {
                        nombre: "Listado de usuarios",
                        url: 'img/nivelesUsuarios/Listado_Usuarios_Registrados_Movil.png',
                        descripcion: "Listado de usuarios registrados en móvil."
                    }
                ],

                regresarMaster: [
                    {
                        nombre: "Regresar vista master",
                        url: 'img/nivelesUsuarios/Confirmacion_Regresar_Vista_Master_Movil.png',
                        descripcion: "Confirmación para regresar a la vista master."
                    }
                ],

                filtroFinal: [
                    {
                        nombre: "I. Confirmación de Filtrado",
                        url: "img/nivelesUsuarios/Confirmacion_Filtrado_Vista_Usuario_Final_Movil.png",
                        descripcion: "Mensaje de confirmación para ver el espacio de trabajo del usuario final."
                    },
                    {
                        nombre: "II. Botón de Aceptar",
                        url: "img/nivelesUsuarios/Confirmacion_Filtrado_Vista_Usuario_Final_Movil_2.png",
                        descripcion: "Presionar el botón Aceptar."
                    },
                    {
                        nombre: "III. Vista Filtrada",
                        url: "img/nivelesUsuarios/Pantalla_Monitoreo_Filtrada_Usuario_Final_Movil.png",
                        descripcion: "Vista de monitoreo filtrada para usuario final."
                    },
                    {
                        nombre: "III. Vista Filtrada",
                        url: "img/nivelesUsuarios/Pantalla_Monitoreo_Filtrada_Usuario_Final_Movil_2.png",
                        descripcion: "Vista de monitoreo filtrada para usuario final."
                    }
                ],

                filtroAdmin: [
                    {
                        nombre: "I. Confirmación de Filtrado",
                        url: "img/nivelesUsuarios/Confirmacion_Filtrado_Vista_Administrador_Movil.png",
                        descripcion: "Mensaje de confirmación para ver el espacio del administrador."
                    },
                    {
                        nombre: "II. Botón de Aceptar",
                        url: "img/nivelesUsuarios/Confirmacion_Filtrado_Vista_Administrador_Movil_2.png",
                        descripcion: "Presionar el botón Aceptar."
                    },
                    {
                        nombre: "III. Vista Filtrada",
                        url: "img/nivelesUsuarios/Pantalla_Monitoreo_Filtrada_Administrador_Movil.png",
                        descripcion: "Vista filtrada para administrador."
                    },
                    {
                        nombre: "III. Vista Filtrada",
                        url: "img/nivelesUsuarios/Pantalla_Monitoreo_Filtrada_Administrador_Movil_2.png",
                        descripcion: "Vista filtrada para administrador."
                    }
                ]
            }
        }
    },

    computed: {
        itemsListadoUsuarios() {
            return this.plataformaActual === 'web'
                ? this.webData.listadoUsuarios
                : this.mobileData.listadoUsuarios
        },

        itemsRegresarMaster() {
            return this.plataformaActual === 'web'
                ? this.webData.regresarMaster
                : this.mobileData.regresarMaster
        },

        carruselFiltroFinal() {
            return this.plataformaActual === 'web'
                ? this.webData.filtroFinal
                : this.mobileData.filtroFinal
        },

        carruselFiltroAdmin() {
            return this.plataformaActual === 'web'
                ? this.webData.filtroAdmin
                : this.mobileData.filtroAdmin
        }
    }
}
</script>

<style scoped>
.flow-detail-card {
    background: var(--bg-color);
    border: 1px solid var(--border-color);
    border-radius: 10px;
    padding: 16px 18px;
    flex: 1;
}

.flow-detail-title {
    font-size: 13.5px;
    font-weight: 600;
    color: var(--primary-color);
    margin-bottom: 10px;
}

.flow-detail-list {
    margin: 0;
    padding-left: 18px;
}

.flow-detail-list li {
    font-size: 13px;
    line-height: 1.7;
    color: var(--text-color);
    opacity: 0.85;
    margin-bottom: 8px;
}

.mb-6 {
    margin-bottom: 2rem;
}

/* Fade transición */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

/* =========================
   Carrusel
========================= */

.flow-card :deep(.carousel-container) {
    min-height: auto;
    margin-top: auto;
    background: var(--code-bg) !important;
}

.flow-card :deep(.carousel-content),
.flow-card :deep(.carousel-slide),
.flow-card :deep(.carousel-item),
.flow-card :deep(.slide-content),
.flow-card :deep(.carousel-image-wrapper) {
    background: var(--code-bg) !important;
}

.flow-card :deep(.carousel-image-wrapper) {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 360px;
    overflow: hidden;
}

.flow-card :deep(img) {
    width: 100%;
    max-height: 340px;
    object-fit: contain;
    display: block;
    margin: 0 auto;
}

/* =========================
   Layout general
========================= */

.doc-section {
    color: var(--text-color);
    padding: 30px 0;
}

.main-title {
    font-family: 'Lexend', sans-serif;
    font-weight: 700;
    font-size: 26px;
    color: var(--primary-color);
    border-bottom: 2px solid var(--border-color);
    padding-bottom: 12px;
    margin-bottom: 12px;
}

.description {
    font-size: 15px;
    line-height: 1.8;
    color: var(--text-color);
    opacity: 0.85;
}

.tabs-container {
    display: flex;
    gap: 8px;
    background: var(--code-bg);
    border: 1px solid var(--border-color);
    border-radius: 10px;
    padding: 8px;
}

.tab-btn {
    flex: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 16px;
    background: transparent;
    color: var(--text-color);
    font-size: 13px;
    font-weight: 600;
    border: none;
    border-radius: 7px;
    cursor: pointer;
    transition: all 0.2s ease;
    opacity: 0.65;
}

.tab-btn.active {
    background: var(--primary-color);
    color: #ffffff;
    opacity: 1;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.tab-content {
    background: var(--code-bg);
    border: 1px solid var(--border-color);
    border-radius: 10px;
    padding: 24px;
}

.role-header {
    border-left: 4px solid var(--primary-color);
    padding-left: 14px;
}

.role-badge {
    display: inline-block;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    padding: 3px 10px;
    border-radius: 4px;
    margin-bottom: 8px;
}

.badge-final {
    background: #dbeafe;
    color: #1d4ed8;
}

.badge-admin {
    background: #d1fae5;
    color: #065f46;
}

.badge-master {
    background: #fef3c7;
    color: #92400e;
}

.role-desc {
    font-size: 14px;
    color: var(--text-color);
    opacity: 0.8;
    margin: 0;
    line-height: 1.6;
}

.permiso-card {
    background: var(--bg-color);
    padding: 16px;
    border-radius: 8px;
    border: 1px solid var(--border-color);
    height: 100%;
}

.permiso-card h4 {
    font-size: 13.5px;
    font-weight: 700;
    color: var(--primary-color);
    margin-bottom: 8px;
    padding-bottom: 6px;
    border-bottom: 1px solid var(--border-color);
}

.permiso-card p {
    font-size: 13px;
    color: var(--text-color);
    opacity: 0.8;
    margin: 0;
    line-height: 1.6;
}

.section-title-bar {
    display: flex;
    align-items: center;
    gap: 12px;
}

.section-badge {
    background: var(--primary-color);
    color: #ffffff;
    padding: 4px 10px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    border-radius: 4px;
}

.section-title-bar h2 {
    font-size: 20px;
    font-weight: 700;
    color: var(--primary-color);
    margin: 0;
}

.section-desc {
    font-size: 14.5px;
    color: var(--text-color);
    opacity: 0.85;
    margin-bottom: 24px;
    line-height: 1.65;
}

.section-divider {
    border: 0;
    height: 1px;
    background: var(--border-color);
}

.carrusel-wrapper-box {
    background: var(--code-bg);
    border-radius: 10px;
    border: 1px solid var(--border-color);
}

.flow-card {
    background: var(--code-bg);
    border: 1px solid var(--border-color);
    border-radius: 10px;

    display: flex;
    flex-direction: column;
    height: 100%;
}

.flow-title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 15px;
    font-weight: 700;
    color: var(--primary-color);
}

.flow-num {
    width: 26px;
    height: 26px;
    background: var(--primary-color);
    color: #ffffff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
}

.flow-text {
    font-size: 13.5px;
    color: var(--text-color);
    opacity: 0.85;
    line-height: 1.65;
}

.return-master-card {
    background: #fff5f5;
    border: 1px solid #fecaca;
    border-radius: 10px;
}

.return-title {
    font-size: 15px;
    font-weight: 700;
    color: #dc2626;
    margin: 0;
}

.doc-note {
    display: flex;
    gap: 10px;
    padding: 13px 16px;
    border-radius: 6px;
    border: 1px solid;
    font-size: 14px;
}

.note-warning {
    background: #fffbeb;
    border-color: #d97706;
    color: #d97706;
}
</style>